// Builds an absolute URL to the native Audiences list surface. The app router
// mounts under the `/builder` basename (see components/router/router.tsx) with the
// route `/:businessID/audiences`. There is no single-audience route, so audience
// comment deep-links target the list and carry the anchor in the query string;
// ListAudiences reads it to auto-open the matching audience + thread. Centralized
// here so packet hosts can route `audience` comment deep-links to this surface.
export const audiencesUrl = (businessID: number): string =>
  `${window.location.origin}/builder/${businessID}/audiences`
